(function () {
  var SECTION_SELECTOR = '.oddit-section-main-product';

  function initSection(section) {
    initGallery(section);
    initThumbnailScrollbar(section);
    initVariantSelectors(section);
    initAccordions(section);
    initComplementaryCarousel(section);
    initComplementaryQuickAdd(section);
    initPageModals(section);
    initRatingScroll(section);
    initInfoTooltipToggle(section);
    initVariantGallerySync(section);
    initAddonImageSync(section);
    initMainAddToCart(section);
    recalculateCartTotal(section);

    // Recommendations are injected asynchronously and replace the
    // complementary block's innerHTML, which destroys the carousel scroll
    // listener. Rebind it whenever the recommendations script announces a
    // load.
    section.addEventListener('oddit:recommendations:loaded', function () {
      initComplementaryCarousel(section);
    });
  }

  /**
   * Custom thumbnail scrollbar (TT1-26 redo). The native horizontal scrollbar
   * is hidden via CSS on every browser; we render our own slim track + thumb
   * div pair as a sibling after the rail so the look and position are
   * identical everywhere (no Mac/Windows/Linux/Firefox/Chrome variation that
   * QA has to verify per OS). Thumb width = (clientWidth / scrollWidth) and
   * thumb position = (scrollLeft / scrollWidth), both as percentages — so it
   * always reflects which part of the rail is in view. Hidden by default;
   * fades in on hover or while scrolling, fades out ~800ms after the last
   * scroll event.
   */
  function initThumbnailScrollbar(section) {
    var rail = section.querySelector('[data-thumbnails]');
    if (!rail || rail.__odditScrollbarReady) return;
    rail.__odditScrollbarReady = true;

    var bar = document.createElement('div');
    bar.className = 'oddit-section-main-product__thumbnails-scrollbar';
    bar.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('div');
    thumb.className = 'oddit-section-main-product__thumbnails-scrollbar-thumb';
    bar.appendChild(thumb);
    rail.parentNode.insertBefore(bar, rail.nextSibling);

    var hideTimer = null;

    function update() {
      var sw = rail.scrollWidth;
      var cw = rail.clientWidth;
      // No overflow (or rail hidden / not laid out yet) — no need to show.
      if (cw === 0 || sw <= cw + 1) {
        bar.style.display = 'none';
        return;
      }
      bar.style.display = '';
      thumb.style.width = (cw / sw * 100) + '%';
      thumb.style.left = (rail.scrollLeft / sw * 100) + '%';
    }

    function show() {
      bar.classList.add('is-visible');
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        bar.classList.remove('is-visible');
      }, 800);
    }

    rail.addEventListener('scroll', function () {
      update();
      show();
    }, { passive: true });

    window.addEventListener('resize', update, { passive: true });
    // Variant change can hide/show thumbnails, which changes scrollWidth.
    section.addEventListener('oddit:gallery:refresh', update);

    update();
  }

  /**
   * Main Add to Cart button. Mirrors the cart drawer's engraving line item
   * pattern: the parent variant carries `_parent_product` + `-Orientation`/
   * `-Font selection`/`-Engraving text` plus a property keyed by the engraving
   * product title (so the upcharge surfaces in the cart UI), and the
   * engraving variant is added as a child line with `_child_product` +
   * `_parent_product: <parent title>`. The cart drawer's existing render
   * logic groups child lines under their parent and hides the standalone
   * engraving product so it doesn't appear as its own row. Bolt/clip
   * add-ons are added as plain separate line items.
   */
  function initMainAddToCart(section) {
    var atc = section.querySelector('.oddit-section-main-product__add-to-cart');
    if (!atc) return;

    function readEngravingValues(form) {
      if (!form) return null;
      var orientationRadio = form.querySelector('input[name="properties[Orientation]"]:checked');
      var orientation = orientationRadio ? orientationRadio.value : '';
      var textInput = form.querySelector('.oddit-section-main-product__engraving-input');
      var text = textInput ? textInput.value : '';
      var fontBtn = form.querySelector('.oddit-section-main-product__font-option--selected');
      var font = fontBtn ? fontBtn.getAttribute('data-font-value') : '';
      return { orientation: orientation, font: font, text: text };
    }

    // Clear the engraving validation error as soon as the user starts typing.
    var engravingTextInputs = section.querySelectorAll('[data-engraving-text-input]');
    for (var ei = 0; ei < engravingTextInputs.length; ei++) {
      (function (input) {
        input.addEventListener('input', function () {
          input.classList.remove('is-invalid');
          var form = input.closest('[data-engraving-form]');
          var err = form ? form.querySelector('[data-engraving-error]') : null;
          if (err) err.hidden = true;
        });
      })(engravingTextInputs[ei]);
    }

    function addWithAddons(btn) {
      if (btn.disabled) return;
      var variantId = Number(btn.getAttribute('data-variant-id'));
      if (!variantId || !window.OdditCartDrawer || typeof window.OdditCartDrawer.addToCart !== 'function') return;

      var productTitle = atc.getAttribute('data-product-title') || '';

      // Detect engraving Yes selection within this section.
      var engravingYes = section.querySelector(
        '[data-engraving-yes].oddit-section-main-product__toggle-option--selected'
      );
      var engravingGroup = engravingYes ? engravingYes.closest('[data-engraving-group]') : null;
      var engravingForm = engravingGroup ? engravingGroup.querySelector('[data-engraving-form]') : null;
      var engravingValues = engravingForm ? readEngravingValues(engravingForm) : null;
      var engravingVariantId = engravingYes ? Number(engravingYes.getAttribute('data-engraving-variant-id')) : 0;
      var engravingTitle = engravingYes ? engravingYes.getAttribute('data-engraving-title') : '';
      var engravingPrice = engravingYes ? engravingYes.getAttribute('data-engraving-price') : '';
      var hasEngraving = !!(engravingYes && engravingVariantId && engravingValues);

      // Validate: if engraving is selected, the custom text field must be
      // non-empty. Surface an inline error and abort the add-to-cart flow
      // so the user can fix it.
      if (hasEngraving && (!engravingValues.text || !engravingValues.text.trim())) {
        var input = engravingForm.querySelector('[data-engraving-text-input]');
        var error = engravingForm.querySelector('[data-engraving-error]');
        if (error) error.hidden = false;
        if (input) {
          input.classList.add('is-invalid');
          input.focus();
        }
        return;
      }

      btn.disabled = true;

      var boltSelected = section.querySelectorAll(
        '[data-bolt-yes].oddit-section-main-product__toggle-option--selected'
      );
      var boltAddons = [];
      for (var i = 0; i < boltSelected.length; i++) {
        var bbtn = boltSelected[i];
        var bid = Number(bbtn.getAttribute('data-addon-variant-id'));
        if (!bid) continue;
        boltAddons.push({
          variantId: bid,
          title: bbtn.getAttribute('data-addon-title') || '',
          price: bbtn.getAttribute('data-addon-price') || ''
        });
      }

      var parentProperties = {};
      if (hasEngraving || boltAddons.length > 0) {
        parentProperties['_parent_product'] = 'true';
      }
      if (hasEngraving) {
        parentProperties['-Orientation'] = engravingValues.orientation;
        parentProperties['-Font selection'] = engravingValues.font;
        parentProperties['-Engraving text'] = engravingValues.text;
        if (engravingTitle) {
          parentProperties[engravingTitle] = engravingPrice || '';
        }
      }
      boltAddons.forEach(function (addon) {
        if (addon.title) {
          parentProperties[addon.title] = addon.price || '';
        }
      });

      var run = window.OdditCartDrawer.addToCart(variantId, 1, parentProperties);

      if (hasEngraving) {
        run = run.then(function () {
          return window.OdditCartDrawer.addToCart(engravingVariantId, 1, {
            '_child_product': 'true',
            '_parent_product': productTitle,
            '-Orientation': engravingValues.orientation,
            '-Font selection': engravingValues.font,
            '-Engraving text': engravingValues.text
          });
        });
      }

      boltAddons.forEach(function (addon) {
        run = run.then(function () {
          return window.OdditCartDrawer.addToCart(addon.variantId, 1, {
            '_child_product': 'true',
            '_parent_product': productTitle
          });
        });
      });

      run
        .then(function () {
          if (window.OdditCartDrawer.open) window.OdditCartDrawer.open();
        })
        .catch(function () {})
        .finally(function () {
          btn.disabled = false;
        });
    }

    atc.addEventListener('click', function () { addWithAddons(this); });

    // Sticky ATC: same flow. Listen on the sticky button itself so we can
    // stopPropagation and prevent the sticky-add-to-cart.js section listener
    // (which only does a plain addToCart with no addons or engraving) from
    // firing as well.
    var stickyAtc = document.querySelector('[data-sticky-add-to-cart]');
    var stickyAddBtn = stickyAtc ? stickyAtc.querySelector('[data-add-to-cart]') : null;
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        addWithAddons(this);
      });
    }
  }

  /**
   * Variant-aware gallery sync. Reads the variants JSON manifest, watches for
   * material/length option clicks, computes the matching variant from the
   * currently selected option values, then shows only thumbnails whose
   * data-variant-ids list is empty (general media) or contains the current
   * variant's id. Also swaps the main image to the new variant's featured
   * media when one exists.
   */
  function initVariantGallerySync(section) {
    var script = document.querySelector('script[data-product-variants]');
    if (!script) return;
    var variants;
    try {
      variants = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants) || variants.length === 0) return;

    function getCurrentSelections() {
      var groups = section.querySelectorAll('[data-option-index]');
      var out = [];
      for (var i = 0; i < groups.length; i++) {
        var index = parseInt(groups[i].getAttribute('data-option-index'), 10);
        var selected = groups[i].querySelector(
          '.oddit-section-main-product__material-option--selected, .oddit-section-main-product__length-option--selected'
        );
        out[index] = selected ? selected.getAttribute('data-option-value') : null;
      }
      return out;
    }

    function findVariant(selections) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.options || v.options.length !== selections.length) continue;
        var match = true;
        for (var j = 0; j < v.options.length; j++) {
          if (v.options[j] !== selections[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    /**
     * For every option button, check whether some available variant exists
     * with that button's value at its option index combined with the OTHER
     * currently selected option values. Toggles the --unavailable class and
     * the disabled attribute so sold-out states update as the user picks.
     */
    function updateOptionAvailability(selections) {
      var groups = section.querySelectorAll('[data-option-index]');
      for (var g = 0; g < groups.length; g++) {
        var optionIndex = parseInt(groups[g].getAttribute('data-option-index'), 10);
        var buttons = groups[g].querySelectorAll('[data-option-value]');

        for (var b = 0; b < buttons.length; b++) {
          var btn = buttons[b];
          var btnValue = btn.getAttribute('data-option-value');
          var candidate = selections.slice();
          candidate[optionIndex] = btnValue;

          var hasAvailable = false;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            if (!v.available) continue;
            if (!v.options || v.options.length !== candidate.length) continue;
            var match = true;
            for (var j = 0; j < v.options.length; j++) {
              if (v.options[j] !== candidate[j]) { match = false; break; }
            }
            if (match) { hasAvailable = true; break; }
          }

          var isMaterial = btn.classList.contains('oddit-section-main-product__material-option');
          var isLength = btn.classList.contains('oddit-section-main-product__length-option');
          if (!isMaterial && !isLength) continue;
          var unavailableClass = isMaterial
            ? 'oddit-section-main-product__material-option--unavailable'
            : 'oddit-section-main-product__length-option--unavailable';

          if (hasAvailable) {
            btn.classList.remove(unavailableClass);
          } else {
            btn.classList.add(unavailableClass);
          }
          // Sold-out options stay selectable (TT1-19) so the shopper can view
          // the variant image and sign up for a back-in-stock notification.
          btn.disabled = false;
        }
      }
    }

    function update() {
      var selections = getCurrentSelections();
      updateOptionAvailability(selections);

      var variant = findVariant(selections);

      var atc = section.querySelector('[data-add-to-cart]');
      var backInStock = section.querySelector('[data-back-in-stock]');
      if (atc) {
        if (!variant || !variant.available) {
          // Sold out: hide Add to Cart and reveal the back-in-stock notify form (TT1-19).
          atc.classList.add('is-sold-out');
          atc.disabled = true;
          atc.hidden = true;
          if (backInStock) {
            backInStock.hidden = false;
            if (variant) {
              var bisTrigger = backInStock.querySelector('[data-bis-trigger]');
              if (bisTrigger) bisTrigger.setAttribute('data-variant-id', variant.id);
            }
          }
        } else {
          atc.classList.remove('is-sold-out');
          atc.disabled = false;
          atc.hidden = false;
          if (backInStock) backInStock.hidden = true;
          // Restore the buyable label when coming back from a sold-out
          // variant (the price span was removed). recalculateCartTotal()
          // at the end of this pass repopulates the price.
          if (!atc.querySelector('[data-cart-total-price]')) {
            atc.innerHTML = 'ADD TO CART • <span data-cart-total-price></span>';
          }
        }
      }

      if (!variant) return;

      var thumbs = section.querySelectorAll('[data-general-media]');
      var visibleCount = 0;
      for (var i = 0; i < thumbs.length; i++) {
        var thumb = thumbs[i];
        var hasNoVariants = thumb.getAttribute('data-general-media') === 'true';
        var mediaId = parseInt(thumb.getAttribute('data-media-id'), 10);
        var imageId = parseInt(thumb.getAttribute('data-preview-image-id'), 10);
        var matchesMedia = !!variant.featured_media_id && variant.featured_media_id === mediaId;
        var matchesImage = !!variant.featured_image_id && variant.featured_image_id === imageId;
        var isFeaturedMedia = matchesMedia || matchesImage;

        var show = hasNoVariants || isFeaturedMedia;
        thumb.hidden = !show;
        if (show) visibleCount++;

        if (isFeaturedMedia) {
          thumb.classList.add('oddit-section-main-product__thumbnail--active');
        } else {
          thumb.classList.remove('oddit-section-main-product__thumbnail--active');
        }
      }

      var thumbsContainer = section.querySelector('[data-thumbnails]');
      if (thumbsContainer) thumbsContainer.hidden = visibleCount <= 1;

      // Visible thumbnail set just changed for the new variant — let the
      // gallery arrows recompute whether they should show.
      section.dispatchEvent(new CustomEvent('oddit:gallery:refresh'));

      var mainImg = section.querySelector('.oddit-section-main-product__main-image-img');
      if (mainImg && variant.featured_image_src) {
        mainImg.src = variant.featured_image_src;
        if (variant.featured_image_srcset) {
          mainImg.srcset = variant.featured_image_srcset;
        } else {
          mainImg.removeAttribute('srcset');
        }
        if (variant.featured_image_alt) mainImg.alt = variant.featured_image_alt;
        section.__odditBaseImage = {
          src: variant.featured_image_src,
          srcset: variant.featured_image_srcset || '',
          alt: variant.featured_image_alt || ''
        };
      }

      if (atc) {
        atc.setAttribute('data-variant-id', variant.id);
        if (typeof variant.price === 'number') {
          atc.setAttribute('data-base-price-cents', variant.price);
        }
      }

      var priceEl = section.querySelector('[data-product-price]');
      if (priceEl && typeof variant.price === 'number') {
        var priceHtml = '';
        if (typeof variant.compare_at_price === 'number' &&
            variant.compare_at_price > variant.price) {
          priceHtml += '<s>' + formatMoney(variant.compare_at_price) + '</s> ';
        }
        priceHtml += formatMoney(variant.price);
        priceEl.innerHTML = priceHtml;
      }

      var stickyAtc = document.querySelector('[data-sticky-add-to-cart]');
      if (stickyAtc) {
        var stickyImg = stickyAtc.querySelector('.oddit-section-sticky-add-to-cart__image');
        if (stickyImg && variant.featured_image_src) {
          stickyImg.src = variant.featured_image_src;
          if (variant.featured_image_srcset) {
            stickyImg.srcset = variant.featured_image_srcset;
          } else {
            stickyImg.removeAttribute('srcset');
          }
          if (variant.featured_image_alt) stickyImg.alt = variant.featured_image_alt;
        }

        var stickyPrice = stickyAtc.querySelector('[data-sticky-atc-price]');
        if (stickyPrice && typeof variant.price === 'number') {
          stickyPrice.textContent = formatMoney(variant.price);
        }

        var stickySpecs = stickyAtc.querySelector('.oddit-section-sticky-add-to-cart__specs');
        if (stickySpecs && Array.isArray(variant.options)) {
          stickySpecs.innerHTML = '';
          for (var s = 0; s < variant.options.length; s++) {
            if (s > 0) {
              var sep = document.createElement('span');
              sep.className = 'oddit-section-sticky-add-to-cart__spec-separator';
              sep.textContent = '|';
              stickySpecs.appendChild(sep);
            }
            var span = document.createElement('span');
            span.className = 'oddit-section-sticky-add-to-cart__spec';
            span.textContent = variant.options[s];
            stickySpecs.appendChild(span);
          }
        }

        var stickyAddBtn = stickyAtc.querySelector('[data-add-to-cart]');
        if (stickyAddBtn) {
          stickyAddBtn.setAttribute('data-variant-id', variant.id);
          if (variant.available) {
            stickyAddBtn.removeAttribute('disabled');
          } else {
            stickyAddBtn.setAttribute('disabled', '');
          }
        }
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* older browsers */ }

      // Re-run the cart total recalc since the parent variant price changed.
      recalculateCartTotal(section);

      // Variant image + thumbnails are now settled — let the bolt/clip
      // alt-text image sync recompute and override if an add-on is selected.
      section.dispatchEvent(new CustomEvent('oddit:variant:updated'));
    }

    section.addEventListener('click', function (e) {
      var trigger = e.target.closest(
        '.oddit-section-main-product__material-option, .oddit-section-main-product__length-option'
      );
      if (!trigger || trigger.disabled) return;
      // initVariantSelectors is registered first in initSection, so its
      // selection click handler has already toggled --selected by the time
      // this listener fires. Run synchronously instead of deferring with rAF
      // so the option appearance, ATC/back-in-stock visibility, and image all
      // flip in the same paint — no "available then sold out" flicker.
      update();
    });

    // Initial pass: count thumbs the server already filtered, hide the
    // sidebar if only one (or zero) is visible, and sync the variant URL
    // param from the ATC button so refreshes/share-links retain it.
    (function () {
      var thumbsContainer = section.querySelector('[data-thumbnails]');
      if (thumbsContainer) {
        var allThumbs = thumbsContainer.querySelectorAll('[data-general-media]');
        var visibleCount = 0;
        for (var i = 0; i < allThumbs.length; i++) {
          if (!allThumbs[i].hidden) visibleCount++;
        }
        thumbsContainer.hidden = visibleCount <= 1;
      }

      var atc = section.querySelector('[data-add-to-cart]');
      if (atc) {
        var initialId = atc.getAttribute('data-variant-id');
        if (initialId) {
          try {
            var url = new URL(window.location.href);
            if (url.searchParams.get('variant') !== initialId) {
              url.searchParams.set('variant', initialId);
              window.history.replaceState({}, '', url.toString());
            }
          } catch (e) { /* older browsers */ }
        }
      }
    })();
  }

  /**
   * Info tooltip is shown via :hover/:focus-within in CSS. To support
   * "click again to close" on touch/keyboard, force-close the tooltip on
   * the second click by adding a class that overrides the hover/focus rules
   * and blurring the trigger so focus-within releases. The class is cleared
   * on blur or mouseleave so the natural hover/focus behaviour returns.
   */
  function initInfoTooltipToggle(section) {
    var triggers = section.querySelectorAll('.oddit-section-main-product__info-icon-trigger');
    for (var i = 0; i < triggers.length; i++) {
      (function (trigger) {
        var wrap = trigger.closest('.oddit-section-main-product__info-icon-wrap');
        if (!wrap) return;

        var hadFocusBefore = false;

        trigger.addEventListener('mousedown', function () {
          hadFocusBefore = (document.activeElement === trigger);
        });

        trigger.addEventListener('click', function () {
          if (hadFocusBefore) {
            wrap.classList.add('is-clicked-closed');
            this.blur();
          } else {
            wrap.classList.remove('is-clicked-closed');
          }
          hadFocusBefore = false;
        });

        trigger.addEventListener('blur', function () {
          wrap.classList.remove('is-clicked-closed');
        });

        wrap.addEventListener('mouseleave', function () {
          wrap.classList.remove('is-clicked-closed');
        });
      })(triggers[i]);
    }
  }

  /**
   * Clicking the rating block scrolls the page down to the Okendo reviews
   * widget. Falls back silently if the widget isn't on the page.
   */
  function initRatingScroll(section) {
    var ratings = section.querySelectorAll('.oddit-section-main-product__rating');
    for (var i = 0; i < ratings.length; i++) {
      var rating = ratings[i];
      rating.setAttribute('role', 'button');
      rating.setAttribute('tabindex', '0');
      rating.addEventListener('click', scrollToReviews);
      rating.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          scrollToReviews();
        }
      });
    }
  }

  function scrollToReviews() {
    var widget = document.querySelector('[data-oke-widget]');
    if (!widget) return;
    widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function openPageModal(modal) {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closePageModal(modal) {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  function initPageModals(section) {
    var triggers = section.querySelectorAll('[data-page-modal-trigger]');
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', function () {
        var targetId = this.getAttribute('data-page-modal-trigger');
        var modal = document.getElementById(targetId);
        if (modal) openPageModal(modal);
      });
    }

    var modals = section.querySelectorAll('[data-page-modal]');
    for (var j = 0; j < modals.length; j++) {
      (function (modal) {
        modal.addEventListener('click', function (e) {
          if (e.target.closest('[data-page-modal-close]')) {
            closePageModal(modal);
          }
        });
      })(modals[j]);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openModals = section.querySelectorAll('[data-page-modal]:not([hidden])');
      for (var k = 0; k < openModals.length; k++) {
        closePageModal(openModals[k]);
      }
    });
  }

  function formatMoney(cents) {
    var formatted;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.Shopify.money_format) {
      formatted = window.Shopify.formatMoney(cents, window.Shopify.money_format);
    } else {
      formatted = '$' + (cents / 100).toFixed(2);
    }
    // Match Liquid's `money_without_trailing_zeros`: drop the decimals when the
    // amount is a whole dollar (e.g. $99.00 -> $99) but keep them otherwise.
    if (cents % 100 === 0) {
      formatted = formatted.replace(/([.,])0{2}(?=\D*$)/, '');
    }
    return formatted;
  }

  /**
   * Recompute the Add to Cart total = base variant price + every selected
   * bolt/engraving "Yes" toggle's add-on price.
   */
  function recalculateCartTotal(section) {
    var atcBtn = section.querySelector('.oddit-section-main-product__add-to-cart[data-add-to-cart]');
    if (!atcBtn) return;
    var totalEl = atcBtn.querySelector('[data-cart-total-price]');
    if (!totalEl) return;

    var baseCents = parseInt(atcBtn.getAttribute('data-base-price-cents'), 10) || 0;
    var totalCents = baseCents;

    var selectedAddons = section.querySelectorAll(
      '.oddit-section-main-product__toggle-option--selected[data-cart-addon-cents]'
    );
    for (var i = 0; i < selectedAddons.length; i++) {
      var addonCents = parseInt(selectedAddons[i].getAttribute('data-cart-addon-cents'), 10);
      if (!isNaN(addonCents)) {
        totalCents += addonCents;
      }
    }

    var formatted = formatMoney(totalCents);
    totalEl.textContent = formatted;

    // Mirror the addon-inclusive total onto the sticky ATC price so both
    // surfaces always show the same value.
    var stickyPrice = document.querySelector('[data-sticky-add-to-cart] [data-sticky-atc-price]');
    if (stickyPrice) stickyPrice.textContent = formatted;
  }

  /**
   * Complementary card quick-add buttons. Multi-variant products open the
   * cart drawer's quick-add modal (same UI as the cart cross-sell quick-add);
   * single-variant products add directly to cart and pop the drawer open.
   */
  function initComplementaryQuickAdd(section) {
    section.addEventListener('click', function (e) {
      var qaTrigger = e.target.closest('[data-quick-add-trigger]');
      if (qaTrigger && qaTrigger.closest('.oddit-section-main-product__complementary-card')) {
        e.preventDefault();
        var handle = qaTrigger.getAttribute('data-product-handle');
        if (handle && window.OdditCartDrawer && typeof window.OdditCartDrawer.quickAdd === 'function') {
          window.OdditCartDrawer.quickAdd(handle);
        }
        return;
      }

      var directAdd = e.target.closest('[data-complementary-add]');
      if (directAdd) {
        e.preventDefault();
        var variantId = Number(directAdd.getAttribute('data-variant-id'));
        if (!variantId || !window.OdditCartDrawer) return;
        directAdd.disabled = true;
        var addPromise = window.OdditCartDrawer.addToCart(variantId, 1);
        if (addPromise && typeof addPromise.then === 'function') {
          addPromise
            .then(function () { window.OdditCartDrawer.open && window.OdditCartDrawer.open(); })
            .finally(function () { directAdd.disabled = false; });
        } else {
          directAdd.disabled = false;
        }
      }
    });
  }

  /**
   * Complementary carousel: scroll-snap track synced with progress indicator
   */
  function initComplementaryCarousel(section) {
    var track = section.querySelector('.oddit-section-main-product__complementary-grid');
    var indicator = section.querySelector('.oddit-section-main-product__complementary-progress-indicator');
    if (!track || !indicator) return;

    function updateProgress() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        indicator.style.width = '100%';
        return;
      }
      var progress = track.scrollLeft / maxScroll;
      var percentage = 30 + progress * 70;
      indicator.style.width = percentage + '%';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(updateProgress);
      ro.observe(track);
    }
  }

  /**
   * Gallery: thumbnail click + desktop prev/next arrows swap the main image.
   *
   * The main <img> carries its own srcset/sizes, so assigning only .src does
   * nothing visible (the browser keeps the srcset-selected source) and the
   * thumbnail's own src is only 80–160px. We instead swap BOTH src and srcset
   * from the full-size data attributes the server renders onto each thumb.
   *
   * The arrows cycle through the currently VISIBLE thumbnails — i.e. the
   * gallery set for the selected variant (general/"gallery" media plus that
   * variant's featured media) — wrapping at the ends. The variant-sync
   * routine re-filters visibility and fires `oddit:gallery:refresh` so the
   * arrow nav can hide itself when a variant only has a single image.
   */
  function initGallery(section) {
    var mainImage = section.querySelector('.oddit-section-main-product__main-image-img');
    if (!mainImage) return;
    var nav = section.querySelector('[data-gallery-nav]');

    function allThumbs() {
      return section.querySelectorAll('.oddit-section-main-product__thumbnail');
    }

    function visibleThumbs() {
      return section.querySelectorAll('.oddit-section-main-product__thumbnail:not([hidden])');
    }

    // Scroll the thumbnail rail (only) so the given thumb is visible. Adjusts
    // the [data-thumbnails] container's own scroll offset — never the page —
    // so arrow navigation keeps the active thumbnail in view on desktop
    // (vertical rail) without yanking the window.
    function scrollThumbIntoView(thumb) {
      var container = thumb.closest('[data-thumbnails]');
      if (!container) return;
      var cRect = container.getBoundingClientRect();
      var tRect = thumb.getBoundingClientRect();
      if (tRect.top < cRect.top) {
        container.scrollTop -= cRect.top - tRect.top;
      } else if (tRect.bottom > cRect.bottom) {
        container.scrollTop += tRect.bottom - cRect.bottom;
      }
      if (tRect.left < cRect.left) {
        container.scrollLeft -= cRect.left - tRect.left;
      } else if (tRect.right > cRect.right) {
        container.scrollLeft += tRect.right - cRect.right;
      }
    }

    function selectThumb(thumb) {
      if (!thumb) return;
      var fullSrc = thumb.getAttribute('data-full-src');
      var fullSrcset = thumb.getAttribute('data-full-srcset');
      var thumbImg = thumb.querySelector('.oddit-section-main-product__thumbnail-img');

      if (fullSrc) {
        mainImage.src = fullSrc;
        if (fullSrcset) {
          mainImage.srcset = fullSrcset;
        } else {
          mainImage.removeAttribute('srcset');
        }
      } else if (thumbImg) {
        mainImage.src = thumbImg.src;
        mainImage.removeAttribute('srcset');
      }
      if (thumbImg && thumbImg.alt) mainImage.alt = thumbImg.alt;

      var thumbs = allThumbs();
      for (var i = 0; i < thumbs.length; i++) {
        thumbs[i].classList.remove('oddit-section-main-product__thumbnail--active');
        thumbs[i].setAttribute('aria-current', 'false');
      }
      thumb.classList.add('oddit-section-main-product__thumbnail--active');
      thumb.setAttribute('aria-current', 'true');

      scrollThumbIntoView(thumb);
    }

    function step(direction) {
      var thumbs = visibleThumbs();
      if (thumbs.length === 0) return;
      var activeIndex = -1;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('oddit-section-main-product__thumbnail--active')) {
          activeIndex = i;
          break;
        }
      }
      if (activeIndex === -1) activeIndex = 0;
      var nextIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
      selectThumb(thumbs[nextIndex]);
    }

    function refreshNav() {
      if (!nav) return;
      nav.hidden = visibleThumbs().length <= 1;
    }

    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('.oddit-section-main-product__thumbnail');
      if (thumb) {
        selectThumb(thumb);
        return;
      }
      if (e.target.closest('[data-gallery-prev]')) {
        step(-1);
        return;
      }
      if (e.target.closest('[data-gallery-next]')) {
        step(1);
      }
    });

    // Touch swipe on the main image (touch devices only — desktop keeps the
    // on-image arrows). A clear horizontal swipe past the threshold steps the
    // gallery: swipe left -> next, swipe right -> previous. Vertical-dominant
    // drags are ignored and listeners are passive, so native page scrolling
    // is never blocked.
    var mainImageEl = section.querySelector('.oddit-section-main-product__main-image');
    if (mainImageEl) {
      var SWIPE_THRESHOLD = 40;
      var touchStartX = 0;
      var touchStartY = 0;

      mainImageEl.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        touchStartX = t.clientX;
        touchStartY = t.clientY;
      }, { passive: true });

      mainImageEl.addEventListener('touchend', function (e) {
        if (visibleThumbs().length <= 1) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - touchStartX;
        var dy = t.clientY - touchStartY;
        if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) <= Math.abs(dy)) return;
        step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    section.addEventListener('oddit:gallery:refresh', refreshNav);

    // The bolt/clip add-on sync resolves a target image by alt text and asks
    // the gallery to show it. Reveal the thumb (it may be a variant-specific
    // image the variant filter hid) before selecting so it appears in the rail.
    section.addEventListener('oddit:gallery:select-thumb', function (e) {
      var thumb = e.detail && e.detail.thumb;
      if (!thumb) return;
      if (thumb.hidden) thumb.hidden = false;
      selectThumb(thumb);
    });

    // --- Fullscreen zoomable, scrollable lightbox (TT1-7) ---
    var lightbox = section.querySelector('[data-lightbox]');
    if (lightbox) {
      var lbScroll = lightbox.querySelector('[data-lightbox-scroll]');

      // Build the lightbox from the current variant's visible gallery images.
      // Returns the <img> matching the active thumbnail so we can scroll to it.
      var buildLightbox = function () {
        if (!lbScroll) return null;
        lbScroll.innerHTML = '';
        var thumbs = visibleThumbs();
        var activeImg = null;
        for (var i = 0; i < thumbs.length; i++) {
          var t = thumbs[i];
          var src = t.getAttribute('data-zoom-src') || t.getAttribute('data-full-src');
          var tImg = t.querySelector('.oddit-section-main-product__thumbnail-img');
          if (!src && tImg) src = tImg.src;
          if (!src) continue;
          var img = document.createElement('img');
          img.className = 'oddit-section-main-product__lightbox-img';
          img.src = src;
          img.alt = (tImg && tImg.alt) || '';
          img.loading = 'lazy';
          img.setAttribute('data-lightbox-zoomable', '');
          lbScroll.appendChild(img);
          if (t.classList.contains('oddit-section-main-product__thumbnail--active')) {
            activeImg = img;
          }
        }
        // Single-image products have no thumbnail rail — fall back to the main image.
        if (!lbScroll.children.length && mainImage) {
          var only = document.createElement('img');
          only.className = 'oddit-section-main-product__lightbox-img';
          only.src = mainImage.src;
          only.alt = mainImage.alt || '';
          only.setAttribute('data-lightbox-zoomable', '');
          lbScroll.appendChild(only);
          activeImg = only;
        }
        return activeImg;
      };

      var openLightbox = function () {
        var activeImg = buildLightbox();
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        lightbox.classList.add('is-open');
        if (activeImg) {
          activeImg.scrollIntoView({ block: 'center' });
        } else if (lbScroll) {
          lbScroll.scrollTop = 0;
        }
        var closeBtn = lightbox.querySelector('[data-lightbox-close]');
        if (closeBtn) closeBtn.focus();
      };

      var closeLightbox = function () {
        lightbox.classList.remove('is-open');
        lightbox.hidden = true;
        document.body.style.overflow = '';
        var zoomed = lbScroll ? lbScroll.querySelectorAll('.is-zoomed') : [];
        for (var i = 0; i < zoomed.length; i++) zoomed[i].classList.remove('is-zoomed');
      };

      // Open: explicit zoom button, or clicking the main image (but not the
      // overlaid prev/next arrows).
      section.addEventListener('click', function (e) {
        if (e.target.closest('[data-lightbox-open]')) {
          openLightbox();
          return;
        }
        if (e.target.closest('.oddit-section-main-product__main-image-img') &&
            !e.target.closest('[data-gallery-nav]')) {
          openLightbox();
        }
      });

      lightbox.addEventListener('click', function (e) {
        if (e.target.closest('[data-lightbox-close]')) {
          closeLightbox();
          return;
        }
        var zoomable = e.target.closest('[data-lightbox-zoomable]');
        if (zoomable) {
          zoomable.classList.toggle('is-zoomed');
          return;
        }
        // Click on the empty backdrop (not an image) closes.
        if (e.target === lightbox || e.target === lbScroll) {
          closeLightbox();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
          closeLightbox();
        }
      });
    }

    refreshNav();
  }

  /**
   * Bolt/clip add-on image sync. Ports the legacy product-form.js
   * `changeImageOnAddOnSelect` behaviour into this section: the merchant
   * names each gallery image's Alt text by the selected option values joined
   * with "+", with "+Bolt"/"+Clip" appended for the add-on state, and an
   * optional ":<addon-variant-title>" when such an image exists. e.g.
   * "Titanium+Standard", "Titanium+Standard+Bolt", "...+Bolt:Damascus".
   *
   * On a variant change (after variant-sync settles) or a bolt/clip toggle,
   * we rebuild that key, find the thumbnail whose image alt matches, and ask
   * the gallery to show it. No-op for products without bolt/clip add-ons, and
   * a no-op when no image matches (so non-conforming products are unaffected).
   */
  function initAddonImageSync(section) {
    if (!section.querySelector('[data-bolt-upgrade]')) return;

    function selectedOptionValues() {
      var groups = section.querySelectorAll('[data-option-index]');
      var byIndex = [];
      for (var i = 0; i < groups.length; i++) {
        var idx = parseInt(groups[i].getAttribute('data-option-index'), 10);
        var sel = groups[i].querySelector(
          '.oddit-section-main-product__material-option--selected, .oddit-section-main-product__length-option--selected'
        );
        var val = sel ? sel.getAttribute('data-option-value') : null;
        if (val && val.trim() !== '') byIndex[idx] = val;
      }
      var out = [];
      for (var k = 0; k < byIndex.length; k++) {
        if (byIndex[k]) out.push(byIndex[k]);
      }
      return out;
    }

    function selectedAddon(kind) {
      var yeses = section.querySelectorAll(
        '[data-bolt-yes].oddit-section-main-product__toggle-option--selected'
      );
      for (var i = 0; i < yeses.length; i++) {
        if ((yeses[i].getAttribute('data-addon-kind') || '').toLowerCase() === kind) {
          return yeses[i];
        }
      }
      return null;
    }

    function thumbByAlt(alt) {
      if (!alt) return null;
      var thumbs = section.querySelectorAll('.oddit-section-main-product__thumbnail');
      for (var i = 0; i < thumbs.length; i++) {
        var img = thumbs[i].querySelector('.oddit-section-main-product__thumbnail-img');
        if (img && img.getAttribute('alt') === alt) return thumbs[i];
      }
      return null;
    }

    // Mirrors the legacy order/casing: bolt then clip, "Bolt"/"Clip" alone
    // when there are no options, else "+Bolt"/"+Clip". The ":<variant-title>"
    // suffix is only used when an image with that exact alt actually exists.
    function appendAddon(base, kind, label) {
      var addon = selectedAddon(kind);
      if (!addon) return base;
      var next = base === '' ? label : base + '+' + label;
      var vt = addon.getAttribute('data-addon-variant-title');
      if (vt && vt.trim() !== '' && thumbByAlt(next + ':' + vt)) {
        next = next + ':' + vt;
      }
      return next;
    }

    function apply() {
      var hasAddon = selectedAddon('bolt') || selectedAddon('clip');
      var alt = selectedOptionValues().join('+');
      alt = appendAddon(alt, 'bolt', 'Bolt');
      alt = appendAddon(alt, 'clip', 'Clip');
      var thumb = thumbByAlt(alt);
      if (thumb) {
        section.dispatchEvent(new CustomEvent('oddit:gallery:select-thumb', {
          detail: { thumb: thumb }
        }));
        return;
      }
      // No alt-named image matched. When no upgrade is selected, revert to the
      // base variant image so toggling the bolt/clip upgrade off restores the
      // original picture (TT1-24). When an upgrade IS selected but has no
      // dedicated image, leave the current image untouched.
      if (!hasAddon) {
        var base = section.__odditBaseImage;
        var mainImg = section.querySelector('.oddit-section-main-product__main-image-img');
        if (base && mainImg) {
          mainImg.src = base.src;
          if (base.srcset) {
            mainImg.srcset = base.srcset;
          } else {
            mainImg.removeAttribute('srcset');
          }
          if (base.alt) mainImg.alt = base.alt;
        }
      }
    }

    // Capture the server-rendered main image as the initial base (no upgrade is
    // selected on load) so the first toggle-off has something to revert to.
    var initialMainImg = section.querySelector('.oddit-section-main-product__main-image-img');
    if (initialMainImg && !section.__odditBaseImage) {
      section.__odditBaseImage = {
        src: initialMainImg.src,
        srcset: initialMainImg.getAttribute('srcset') || '',
        alt: initialMainImg.alt || ''
      };
    }

    section.addEventListener('oddit:variant:updated', apply);

    section.addEventListener('click', function (e) {
      var toggle = e.target.closest(
        '[data-bolt-toggle] .oddit-section-main-product__toggle-option'
      );
      if (!toggle) return;
      // The toggle's --selected class is set synchronously by another click
      // handler; recompute on the next frame so we read the new state.
      window.requestAnimationFrame(apply);
    });

    apply();
  }

  /**
   * Variant selectors: material, length, bolt, engraving toggle
   */
  function initVariantSelectors(section) {
    // Material options. Scope --selected rotation to the same option group
    // (closest [data-option-index]) so multiple option groups stay independent.
    section.addEventListener('click', function (e) {
      var option = e.target.closest('.oddit-section-main-product__material-option');
      if (!option || option.disabled) return;

      var group = option.closest('[data-option-index]') || section;
      var siblings = group.querySelectorAll('.oddit-section-main-product__material-option');
      for (var i = 0; i < siblings.length; i++) {
        siblings[i].classList.remove('oddit-section-main-product__material-option--selected');
        siblings[i].setAttribute('aria-pressed', 'false');
        var check = siblings[i].querySelector('.oddit-section-main-product__material-check');
        if (check) check.style.display = 'none';
      }
      option.classList.add('oddit-section-main-product__material-option--selected');
      option.setAttribute('aria-pressed', 'true');
      var selectedCheck = option.querySelector('.oddit-section-main-product__material-check');
      if (selectedCheck) selectedCheck.style.display = '';

      // Update this group's label value (the span inside the same group's header).
      var nameEl = option.querySelector('.oddit-section-main-product__material-name');
      if (nameEl) {
        var labelValue = group.querySelector('.oddit-section-main-product__variant-label-value');
        if (labelValue) {
          var textContent = nameEl.textContent.trim().split('(')[0].trim();
          labelValue.textContent = textContent;
        }
      }
    });

    // Length options. Same per-group scoping — critical when a product has
    // more than one non-"material" option (e.g. Length + Color both render
    // as length-options) so clicking one group doesn't strip --selected
    // off the other group.
    section.addEventListener('click', function (e) {
      var option = e.target.closest('.oddit-section-main-product__length-option');
      if (!option || option.disabled) return;

      var group = option.closest('[data-option-index]') || section;
      var siblings = group.querySelectorAll('.oddit-section-main-product__length-option');
      for (var i = 0; i < siblings.length; i++) {
        siblings[i].classList.remove('oddit-section-main-product__length-option--selected');
        siblings[i].setAttribute('aria-pressed', 'false');
      }
      option.classList.add('oddit-section-main-product__length-option--selected');
      option.setAttribute('aria-pressed', 'true');

      var labelValue = group.querySelector('.oddit-section-main-product__variant-label-value');
      if (labelValue) {
        labelValue.textContent = option.getAttribute('data-option-value') || '';
      }
    });

    // Toggle options (bolt upgrade, engraving)
    var toggleGroups = section.querySelectorAll('.oddit-section-main-product__toggle-options');
    for (var g = 0; g < toggleGroups.length; g++) {
      (function (group) {
        group.addEventListener('click', function (e) {
          var option = e.target.closest('.oddit-section-main-product__toggle-option');
          if (!option) return;

          var siblings = group.querySelectorAll('.oddit-section-main-product__toggle-option');
          for (var i = 0; i < siblings.length; i++) {
            siblings[i].classList.remove('oddit-section-main-product__toggle-option--selected');
            siblings[i].setAttribute('aria-pressed', 'false');
          }
          option.classList.add('oddit-section-main-product__toggle-option--selected');
          option.setAttribute('aria-pressed', 'true');

          // Show/hide engraving form when this is the engraving toggle group
          if (group.hasAttribute('data-engraving-toggle')) {
            var engravingGroup = group.closest('[data-engraving-group]');
            if (engravingGroup) {
              var form = engravingGroup.querySelector('[data-engraving-form]');
              if (form) {
                if (option.hasAttribute('data-engraving-yes')) {
                  form.hidden = false;
                } else {
                  form.hidden = true;
                }
              }
            }
          }

          // Show/hide bolt/clip add-on note when this is the bolt toggle group
          if (group.hasAttribute('data-bolt-toggle')) {
            var boltGroup = group.closest('[data-bolt-upgrade]');
            if (boltGroup) {
              var note = boltGroup.querySelector('[data-bolt-note]');
              if (note) {
                if (option.hasAttribute('data-bolt-yes')) {
                  note.hidden = false;
                } else {
                  note.hidden = true;
                }
              }
            }
          }

          recalculateCartTotal(section);
        });
      })(toggleGroups[g]);
    }

    // Font options (engraving form). Mirrors the cart drawer's behaviour:
    // selecting a font also restyles the engraving input so the user can
    // preview the font as they type.
    var ENGRAVING_FONT_FAMILIES = {
      'Helvetica':   "'Helvetica-Engraving', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      'Stanislav':   "'Stanislav-Engraving', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      'Tungsten':    "'Tungsten-Engraving', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      'Telegraphem': "'Telegraphem-Engraving', 'Helvetica Neue', Helvetica, Arial, sans-serif"
    };

    // Preview size per engraving font. Condensed faces (e.g. Tungsten) read
    // smaller at a given pixel size, so bump them up to keep the in-field
    // preview large and legible. (TT1-13)
    var ENGRAVING_FONT_SIZES = {
      _default:      '22px',
      'Helvetica':   '22px',
      'Stanislav':   '22px',
      'Tungsten':    '28px',
      'Telegraphem': '22px'
    };

    var fontOptions = section.querySelectorAll('.oddit-section-main-product__font-option');
    if (fontOptions.length > 0) {
      // Apply the initially-selected font to each engraving form's input on
      // load so the placeholder preview already matches the default font.
      var initialSelected = section.querySelectorAll(
        '.oddit-section-main-product__font-option--selected'
      );
      for (var s = 0; s < initialSelected.length; s++) {
        var iSel = initialSelected[s];
        var iVal = iSel.getAttribute('data-font-value');
        var iForm = iSel.closest('.oddit-section-main-product__engraving-form');
        var iInput = iForm ? iForm.querySelector('.oddit-section-main-product__engraving-input') : null;
        if (iInput && ENGRAVING_FONT_FAMILIES[iVal]) {
          iInput.style.fontFamily = ENGRAVING_FONT_FAMILIES[iVal];
          iInput.style.fontSize = ENGRAVING_FONT_SIZES[iVal] || ENGRAVING_FONT_SIZES._default;
        }
      }

      section.addEventListener('click', function (e) {
        var option = e.target.closest('.oddit-section-main-product__font-option');
        if (!option) return;

        // Scope the selected/aria state to the same font picker (one per
        // engraving form) so multi-engraving products stay independent.
        var picker = option.closest('.oddit-section-main-product__engraving-font-options') || option.parentElement;
        var siblings = picker.querySelectorAll('.oddit-section-main-product__font-option');
        for (var i = 0; i < siblings.length; i++) {
          siblings[i].classList.remove('oddit-section-main-product__font-option--selected');
          siblings[i].setAttribute('aria-pressed', 'false');
        }
        option.classList.add('oddit-section-main-product__font-option--selected');
        option.setAttribute('aria-pressed', 'true');

        var fontValue = option.getAttribute('data-font-value');
        var form = option.closest('.oddit-section-main-product__engraving-form');
        var input = form ? form.querySelector('.oddit-section-main-product__engraving-input') : null;
        if (input && fontValue && ENGRAVING_FONT_FAMILIES[fontValue]) {
          input.style.fontFamily = ENGRAVING_FONT_FAMILIES[fontValue];
          input.style.fontSize = ENGRAVING_FONT_SIZES[fontValue] || ENGRAVING_FONT_SIZES._default;
        }
      });
    }
  }

  /**
   * Accordions are handled by native <details> — no JS needed for open/close.
   * Optional: close other accordions when one opens (exclusive mode).
   */
  function initAccordions(section) {
    var accordions = section.querySelectorAll('.oddit-section-main-product__accordion');
    if (accordions.length === 0) return;

    for (var i = 0; i < accordions.length; i++) {
      accordions[i].addEventListener('toggle', function (e) {
        if (!e.target.open) return;
        for (var j = 0; j < accordions.length; j++) {
          if (accordions[j] !== e.target && accordions[j].open) {
            accordions[j].open = false;
          }
        }
      });
    }
  }

  // Init all instances on page
  var sections = document.querySelectorAll(SECTION_SELECTOR);
  for (var s = 0; s < sections.length; s++) {
    initSection(sections[s]);
  }

  // Re-init on Shopify section load
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();